import { jsx as _jsx } from "react/jsx-runtime";
import { DeviceContentProvider } from 'console/shared/contexts/device';
import { memo } from 'react';
import { useAppSelector, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
import { BoilersHeatingCircuits } from 'console/shared/components/panels/boilers-heating-circuits';
import { CustomControls } from 'console/shared/components/panels/custom-controls';
import { HeatingModes } from 'console/shared/components/panels/heating-modes';
import { DashboardPanel } from 'console/shared/components/tab/panel/dashboard';
import { Thermometers } from 'console/shared/components/panels/thermometers';
import { HeatingCircuits } from 'console/shared/components/panels/heating-circuits';
import { Sensors } from 'console/shared/components/panels/sensors';
import { isVehicleDevice } from 'console/shared/contexts/device/config/utils';
import { VehicleDeviceProvider } from 'console/shared/contexts/vehicle-device';
import { HeatingDeviceContentProvider } from 'console/shared/contexts/heating-device';
import { TabLayout } from 'console/shared/components/tab/layout';
import { GuardControl } from 'console/shared/components/panels/guard-control';
import { GuardZones } from 'console/shared/components/panels/guard-zones';
import { RfIndicators } from 'console/shared/components/panels/rf-indicators';
import { VehiclePanel } from 'console/shared/components/panels/vehicle-panel';
import { RfIndicatorsPanel } from 'console/shared/components/tab/panel/rf-indicators';
import { select_ui_settings } from 'console/redux/settings-actions';
import { DefaultTabKey } from 'console/shared/content/tab/types';
const dashboard_templates = {
    HeatingCircuitsTemplate: DashboardPanel(HeatingCircuits),
    BoilerHeatingCircuitsTemplate: DashboardPanel(BoilersHeatingCircuits),
    HeatingModesTemplate: DashboardPanel(HeatingModes),
    GuardZonesTemplate: DashboardPanel(GuardZones),
    GuardControlTemplate: DashboardPanel(GuardControl),
    CustomControlsTemplate: DashboardPanel(CustomControls),
    VehiclePanelTemplate: DashboardPanel(VehiclePanel, { can_hide: false }),
    ThermometersTemplate: DashboardPanel(Thermometers),
    SensorsTemplate: DashboardPanel(Sensors),
    RfIndicatorsTemplate: RfIndicatorsPanel(RfIndicators),
};
export const DashboardDeviceContentProvider = memo(function DashboardDeviceContentProvider(props) {
    const { children, device_id } = props;
    const device = usePartialAppSelector(selectDevice, device_id);
    const is_vehicle_device = device?.device_type
        ? isVehicleDevice(device.device_type)
        : false;
    const DeviceProvider = is_vehicle_device
        ? VehicleDeviceProvider
        : HeatingDeviceContentProvider;
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const custom_content = dashboard_settings?.devices?.find(({ id }) => device_id === id)?.items;
    if (!device) {
        return null;
    }
    return (_jsx(DeviceContentProvider, { device: device, tab_key: DefaultTabKey.dashboard, children: _jsx(DeviceProvider, { custom_content: custom_content && custom_content.length > 0
                ? custom_content
                : undefined, templates: dashboard_templates, children: _jsx(TabLayout, { px: 0, pb: 0.5, height: "100%", overflow: "auto", support_tab_control: false, children: children }) }) }));
});
